import authService from './authService';

class AgentService {
  /**
   * List all available gateways from the Agent Parent API
   * @param {string} agentParentApiUrl - Base URL of the agent parent API (e.g., https://xxx.execute-api.us-east-1.amazonaws.com/prod)
   */
  async listGateways(agentParentApiUrl) {
    // API Gateway Cognito authorizers use ID tokens, not access tokens
    const idToken = await authService.getIdToken();
    
    console.log('Fetching gateways from:', agentParentApiUrl);
    console.log('ID token (first 20 chars):', idToken?.substring(0, 20) + '...');
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };

    try {
      // Append /gateways path to the agent parent API URL
      const listGatewaysUrl = `${agentParentApiUrl}/gateways`;
      
      console.log('Full URL:', listGatewaysUrl);
      
      const response = await fetch(listGatewaysUrl, {
        method: 'GET',
        headers: headers,
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response body:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
      }

      const data = await response.json();
      console.log('Gateway data:', data);
      return data.gateways || [];
    } catch (error) {
      console.error('Error listing gateways:', error);
      throw error;
    }
  }

  /**
   * Get the user's IAM role ARN
   * @param {string} agentParentApiUrl - Base URL of the agent parent API
   */
  async getUserArn(agentParentApiUrl) {
    const idToken = await authService.getIdToken();
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };

    try {
      const userArnsUrl = `${agentParentApiUrl}/user-arns`;
      
      const response = await fetch(userArnsUrl, {
        method: 'GET',
        headers: headers,
      });

      if (response.status === 404) {
        // User hasn't set an ARN yet
        return null;
      }

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response body:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting user ARN:', error);
      throw error;
    }
  }

  /**
   * Set or update the user's IAM role ARN
   * @param {string} agentParentApiUrl - Base URL of the agent parent API
   * @param {string} roleArn - The IAM role ARN to associate with the user
   */
  async putUserArn(agentParentApiUrl, roleArn) {
    const idToken = await authService.getIdToken();
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };

    try {
      const userArnsUrl = `${agentParentApiUrl}/user-arns`;
      
      const response = await fetch(userArnsUrl, {
        method: 'PUT',
        headers: headers,
        body: JSON.stringify({ roleArn }),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response body:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error setting user ARN:', error);
      throw error;
    }
  }

  /**
   * Delete the user's IAM role ARN
   * @param {string} agentParentApiUrl - Base URL of the agent parent API
   */
  async deleteUserArn(agentParentApiUrl) {
    const idToken = await authService.getIdToken();
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${idToken}`,
    };

    try {
      const userArnsUrl = `${agentParentApiUrl}/user-arns`;
      
      const response = await fetch(userArnsUrl, {
        method: 'DELETE',
        headers: headers,
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error response body:', errorText);
        throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error deleting user ARN:', error);
      throw error;
    }
  }
}

export default new AgentService();
